import { render, staticRenderFns } from "./ManageSettings.vue?vue&type=template&id=35972990&"
import script from "./ManageSettings.vue?vue&type=script&lang=js&"
export * from "./ManageSettings.vue?vue&type=script&lang=js&"
import style0 from "./ManageSettings.vue?vue&type=style&index=0&id=35972990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports